import { Injectable, Component, NgModule } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class CookieConsentModel {
}
if (false) {
    /** @type {?} */
    CookieConsentModel.prototype.IsGARefused;
    /** @type {?} */
    CookieConsentModel.prototype.IsThirdPartyRefused;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieBarSettingsModel {
    constructor() {
        this.isActive = false;
    }
    ;
}
if (false) {
    /** @type {?} */
    CookieBarSettingsModel.prototype.isActive;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieBarService {
    constructor() {
        //To make sure that tryShow() works one and only one time only, even if called several times from client.
        this.isCookieBarProcessed = false;
        this.cookieBarCookieName = "cookie_rst";
        this.cookieBarCookieValue = "1";
        this.consentCookieName = "CONSENT";
        this.cookieBarSettingsSubject = new BehaviorSubject(null);
        this.cookieBarSettings$ = this.cookieBarSettingsSubject.asObservable();
        //depricated | cookie-bar is replaced with cookie consent
        this.hide = (/**
         * @return {?}
         */
        () => {
            if (!this.getCookieValue(this.cookieBarCookieName)) {
                this.setCookieBarCookie();
            }
            /** @type {?} */
            var settings = this.cookieBarSettingsSubject.getValue();
            settings.isActive = false;
            this.cookieBarSettingsSubject.next(settings);
            window.removeEventListener("click", this.hide);
            return;
        });
    }
    /**
     * @private
     * @return {?}
     */
    get cookieBarCookieDomain() {
        return window.location.hostname.substr(window.location.hostname.indexOf("."));
    }
    /**
     * @private
     * @return {?}
     */
    get cookieBarCookieExpirationTime() {
        /** @type {?} */
        let d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        return d;
    }
    /**
     * @return {?}
     */
    getCookieConsent() {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            /** @type {?} */
            var result = (/** @type {?} */ ({ IsGARefused: false, IsThirdPartyRefused: false }));
            try {
                //cookie-consent value is pipe delimited. parse the same to javascript object.
                /** @type {?} */
                var parsePipeDelimited = (/**
                 * @param {?} cookieValue
                 * @return {?}
                 */
                (cookieValue) => {
                    /** @type {?} */
                    var result = {};
                    cookieValue.split('|').forEach((/**
                     * @param {?} x
                     * @return {?}
                     */
                    function (x) {
                        /** @type {?} */
                        var arr = x.split('=');
                        arr[1] && (result[arr[0]] = arr[1]);
                    }));
                    return result;
                });
                /** @type {?} */
                var cookieConsentValue = this.getCookieValue(this.consentCookieName);
                if (cookieConsentValue != null && cookieConsentValue) {
                    /** @type {?} */
                    var cookieObject = parsePipeDelimited(cookieConsentValue);
                    result.IsGARefused = cookieObject && cookieObject["ga"] && cookieObject["ga"] == "false";
                }
            }
            catch (err) {
                console.log("Error reading consent cookie." + err);
            }
            finally {
                observer.next(result);
                observer.complete();
            }
        }));
    }
    //depricated | cookie-bar is replaced with cookie consent
    /**
     * @return {?}
     */
    tryShowAsync() {
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        resolve => {
            if (this.isCookieBarProcessed) {
                resolve(false);
                return;
            }
            else {
                this.isCookieBarProcessed = true;
            }
            /** @type {?} */
            var settings = new CookieBarSettingsModel();
            if (settings) {
                this.cookieBarSettingsSubject.next(settings);
            }
            if (this.getCookieValue(this.cookieBarCookieName)) {
                resolve(false);
                return;
            }
            else {
                settings.isActive = true;
                this.cookieBarSettingsSubject.next(settings);
            }
            window.addEventListener("click", this.hide);
            resolve(true);
            return;
        }));
    }
    /**
     * @private
     * @return {?}
     */
    setCookieBarCookie() {
        /** @type {?} */
        let expires = this.cookieBarCookieExpirationTime.toUTCString();
        /** @type {?} */
        let domain = this.cookieBarCookieDomain;
        document.cookie = `${this.cookieBarCookieName}=${this.cookieBarCookieValue};expires=${expires};path=/;domain=${domain}`;
    }
    /**
     * @private
     * @param {?} cookieName
     * @return {?}
     */
    getCookieValue(cookieName) {
        /** @type {?} */
        let ca = document.cookie.split(';');
        /** @type {?} */
        let caLen = ca.length;
        /** @type {?} */
        let cookieNameVar = `${cookieName}=`;
        /** @type {?} */
        let c;
        for (let i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieNameVar) == 0) {
                return c.substring(cookieNameVar.length, c.length);
            }
        }
        return null;
    }
}
CookieBarService.ɵfac = function CookieBarService_Factory(t) { return new (t || CookieBarService)(); };
CookieBarService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CookieBarService, factory: CookieBarService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieBarService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    CookieBarService.prototype.isCookieBarProcessed;
    /**
     * @type {?}
     * @private
     */
    CookieBarService.prototype.cookieBarCookieName;
    /**
     * @type {?}
     * @private
     */
    CookieBarService.prototype.cookieBarCookieValue;
    /**
     * @type {?}
     * @private
     */
    CookieBarService.prototype.consentCookieName;
    /**
     * @type {?}
     * @private
     */
    CookieBarService.prototype.cookieBarSettingsSubject;
    /** @type {?} */
    CookieBarService.prototype.cookieBarSettings$;
    /** @type {?} */
    CookieBarService.prototype.hide;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieBarElementComponent {
    /**
     * @param {?} cookieBarService
     */
    constructor(cookieBarService) {
        this.cookieBarService = cookieBarService;
        this.settings = null;
        this.policyRelativeUrl = "/politica-de-cookies.aspx";
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.cookieBarService.cookieBarSettings$.subscribe({
            next: (/**
             * @param {?} v
             * @return {?}
             */
            (v) => {
                this.settings = v;
                this.displayClass = this.settings && this.settings.isActive ? "open" : "close";
            })
        });
    }
    /**
     * @return {?}
     */
    hideCookieBar() {
        this.cookieBarService.hide();
    }
}
CookieBarElementComponent.ɵfac = function CookieBarElementComponent_Factory(t) { return new (t || CookieBarElementComponent)(ɵngcc0.ɵɵdirectiveInject(CookieBarService)); };
CookieBarElementComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CookieBarElementComponent, selectors: [["cookie-bar-element"]], decls: 13, vars: 4, consts: [["id", "cookies"], [1, "container", "flex-container"], [1, "col-xs-12", "text"], ["title", "Pol\u00EDtica de Cookies - Rastreator.com", "target", "blank", 3, "href"], [1, "show-lg"], ["id", "btnCookiesAccept", "href", "javaScript:void(0)", 1, "link-cancel", "hidden-lg", "hidden-md", "cancel", 3, "click"], ["id", "btnCookiesClose", 1, "icon", "icon-cancel", "cancel", 3, "click"]], template: function CookieBarElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "p");
        ɵngcc0.ɵɵtext(4, "\u00A1Humano! En Rastreator.com utilizamos cookies propias y de terceros para personalizar tu experiencia ofreci\u00E9ndote contenidos de tu inter\u00E9s. Puedes tener m\u00E1s detalles ");
        ɵngcc0.ɵɵelementStart(5, "a", 3);
        ɵngcc0.ɵɵtext(6, "aqu\u00ED");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, ".");
        ɵngcc0.ɵɵelement(8, "br", 4);
        ɵngcc0.ɵɵtext(9, "Entendemos que si sigues navegando, est\u00E1s de acuerdo ;)");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "a", 5);
        ɵngcc0.ɵɵlistener("click", function CookieBarElementComponent_Template_a_click_10_listener() { return ctx.hideCookieBar(); });
        ɵngcc0.ɵɵtext(11, "Aceptar");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(12, "span", 6);
        ɵngcc0.ɵɵlistener("click", function CookieBarElementComponent_Template_span_click_12_listener() { return ctx.hideCookieBar(); });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.displayClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.policyRelativeUrl, ɵngcc0.ɵɵsanitizeUrl);
    } }, encapsulation: 2 });
/** @nocollapse */
CookieBarElementComponent.ctorParameters = () => [
    { type: CookieBarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieBarElementComponent, [{
        type: Component,
        args: [{
                selector: 'cookie-bar-element',
                template: "<div id=\"cookies\" class=\"{{displayClass}}\">\r\n  <div class=\"container flex-container\">\r\n    <div class=\"col-xs-12 text\">\r\n\r\n      <p>\u00A1Humano! En Rastreator.com utilizamos cookies propias y de terceros para personalizar tu experiencia ofreci\u00E9ndote contenidos de tu inter\u00E9s. Puedes tener m\u00E1s detalles <a href=\"{{policyRelativeUrl}}\" title=\"Pol\u00EDtica de Cookies - Rastreator.com\" target=\"blank\">aqu\u00ED</a>.<br class=\"show-lg\">Entendemos que si sigues navegando, est\u00E1s de acuerdo ;)</p>\r\n\r\n      <a id=\"btnCookiesAccept\"\r\n         href=\"javaScript:void(0)\"\r\n         (click)=\"hideCookieBar()\"\r\n         class=\"link-cancel hidden-lg hidden-md cancel\">Aceptar</a>\r\n\r\n    </div>\r\n  </div>\r\n  <span id=\"btnCookiesClose\" class=\"icon icon-cancel cancel\" (click)=\"hideCookieBar()\"></span>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: CookieBarService }]; }, null); })();
if (false) {
    /** @type {?} */
    CookieBarElementComponent.prototype.settings;
    /** @type {?} */
    CookieBarElementComponent.prototype.displayClass;
    /** @type {?} */
    CookieBarElementComponent.prototype.policyRelativeUrl;
    /**
     * @type {?}
     * @private
     */
    CookieBarElementComponent.prototype.cookieBarService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieBarModule {
}
CookieBarModule.ɵfac = function CookieBarModule_Factory(t) { return new (t || CookieBarModule)(); };
CookieBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CookieBarModule });
CookieBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieBarModule, [{
        type: NgModule,
        args: [{
                declarations: [CookieBarElementComponent],
                imports: [],
                exports: [CookieBarElementComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CookieBarModule, { declarations: [CookieBarElementComponent], exports: [CookieBarElementComponent] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CookieBarElementComponent, CookieBarModule, CookieBarService, CookieConsentModel };

